/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Help_Center__Shipping_N_Delivery__Answer_1Inputs */

const en_help_center__shipping_n_delivery__answer_1 = /** @type {((inputs: Help_Center__Shipping_N_Delivery__Answer_1Inputs) => LocalizedString) & { parts: (inputs: Help_Center__Shipping_N_Delivery__Answer_1Inputs) => import('../runtime.js').MessagePart[] }} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs: Help_Center__Shipping_N_Delivery__Answer_1Inputs) => LocalizedString} */ (() => {
			return /** @type {LocalizedString} */ (`Typical Shipping Fees:Small packages: Less than 1kg (€5 - €15)Large packages: More than 1kg (€15 - €350)`)
		}),
		{
			parts: /** @type {(inputs: Help_Center__Shipping_N_Delivery__Answer_1Inputs) => import('../runtime.js').MessagePart[]} */ (() => {
				return /** @type {import('../runtime.js').MessagePart[]} */ ([{ type: "text", value: "Typical Shipping Fees:" }, { type: "markup-standalone", name: "br", options: {}, attributes: {} }, { type: "markup-start", name: "strong", options: {}, attributes: {} }, { type: "text", value: "Small packages:" }, { type: "markup-end", name: "strong", options: {}, attributes: {} }, { type: "text", value: " Less than 1kg (€5 - €15)" }, { type: "markup-standalone", name: "br", options: {}, attributes: {} }, { type: "markup-start", name: "strong", options: {}, attributes: {} }, { type: "text", value: "Large packages:" }, { type: "markup-end", name: "strong", options: {}, attributes: {} }, { type: "text", value: " More than 1kg (€15 - €350)" }])
			})
		}
	)
);

/**
* | output |
* | --- |
* | "Typical Shipping Fees:Small packages: Less than 1kg (€5 - €15)Large packages: More than 1kg (€15 - €350)" |
*
* @param {Help_Center__Shipping_N_Delivery__Answer_1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const help_center__shipping_n_delivery__answer_1 = /** @type {((inputs?: Help_Center__Shipping_N_Delivery__Answer_1Inputs, options?: { locale?: "en" }) => LocalizedString) & { parts: (inputs?: Help_Center__Shipping_N_Delivery__Answer_1Inputs, options?: { locale?: "en" }) => import('../runtime.js').MessagePart[] } & import('../runtime.js').MessageMetadata<Help_Center__Shipping_N_Delivery__Answer_1Inputs, { locale?: "en" }, { br: { options: {}; attributes: {}; children: false }; strong: { options: {}; attributes: {}; children: true } }>} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs?: Help_Center__Shipping_N_Delivery__Answer_1Inputs, options?: { locale?: "en" }) => LocalizedString} */ ((inputs = {}, options = {}) => {
			const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
			return en_help_center__shipping_n_delivery__answer_1(inputs)
		}),
		{
			parts: /** @type {(inputs?: Help_Center__Shipping_N_Delivery__Answer_1Inputs, options?: { locale?: "en" }) => import('../runtime.js').MessagePart[]} */ ((inputs = {}, options = {}) => {
				const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
				return typeof en_help_center__shipping_n_delivery__answer_1.parts === "function" ? en_help_center__shipping_n_delivery__answer_1.parts(inputs) : [{ type: "text", value: en_help_center__shipping_n_delivery__answer_1(inputs) }]
			})
		}
	)
);